import {useQueryClient} from '@tanstack/react-query'
import BreadCrumb from 'Components/Common/BreadCrumb'
import DeleteModal from 'Components/Common/DeleteModal'
import withTable from 'Components/Common/Table/withTable'
import CommissionItem from 'Components/Master/CommissionItem'
import {DATA_LIMIT} from 'configs'
import {CommissionRQ} from 'Hooks/Queries'
import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {Container, Row} from 'reactstrap'

export default function ListCommission() {
  const [deleteCommissionId, setDeleteCommissionId] = useState(null)
  const [deleteModal, setDeleteModal] = useState(false)
  const [offset, setOffset] = useState(0)
  const [limit, setLimit] = useState(DATA_LIMIT)
  const [keyword, setKeyword] = useState(null)
  const {status, data, error, isFetching, refetch} =
    CommissionRQ.useGetDataList()(false, keyword, offset, limit)

  const useQuery = useQueryClient()
  const navigate = useNavigate()

  const onDeleteSuccess = (key) => {
    setDeleteModal(false)
    setDeleteCommissionId(null)
    useQuery.invalidateQueries({queryKey: [key]})
    refetch()
  }
  const {mutate: deleteTruck} = CommissionRQ.useDeleteData(onDeleteSuccess)()

  const onDeleteClick = (id) => {
    setDeleteModal(true)
    setDeleteCommissionId(id)
  }

  const onDeleteConfirm = () => {
    deleteTruck(deleteCommissionId)
  }

  const onAddButtonClicked = () => {
    navigate('/app/struktur-harga/trucking/komisi/create')
  }

  const onPageChange = (i) => {
    setOffset(i.selected)
  }

  const onPerPageChange = (i) => {
    setLimit(i)
    setOffset(0)
  }

  const onKeywordChange = (value) => {
    setKeyword(value)
  }

  const CommissionTable = withTable(
    CommissionItem,
    'struktur-harga/trucking/komisi',
    ['NO', 'Action', 'Vendor trucking', 'trucking fee'],
    onDeleteClick,
    onAddButtonClicked,
  )

  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb title='Commission' />

        <Row>
          <CommissionTable
            data={data}
            isFetching={isFetching}
            loading={isFetching}
            error={error}
            status={status}
            onPageChange={onPageChange}
            onPerPageChange={onPerPageChange}
            onKeywordChange={onKeywordChange}
            keyword={keyword}
          />
        </Row>
      </Container>
      <DeleteModal
        onDeleteConfirm={() => onDeleteConfirm()}
        onCloseClick={() => setDeleteModal((v) => !v)}
        show={deleteModal}
        loading={false}
      />
    </div>
  )
}
